import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3d06fdc3")
const _hoisted_1 = { class: "p-d-flex p-ai-center p-jc-end p-mb-3" }
const _hoisted_2 = { class: "p-mr-3 p-mb-0" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Display only active ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Display inactive too ")
const _hoisted_5 = {
  key: 0,
  class: "export_action"
}
const _hoisted_6 = { class: "p-d-flex p-ai-center p-flex-nowrap" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 p-text-bold" }, "Filter by status", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "Duration"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createElementVNode("i", null, "(HH:mm:ss)")
    ])
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 p-text-bold" }, "Filter by status", -1)
const _hoisted_10 = { class: "p-d-flex" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_TicketStatus = _resolveComponent("TicketStatus")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_PaymentStatus = _resolveComponent("PaymentStatus")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_TicketFinishStatus = _resolveComponent("TicketFinishStatus")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_AddTicketDialog = _resolveComponent("AddTicketDialog")!
  const _component_TicketDisputeResolverDialog = _resolveComponent("TicketDisputeResolverDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, [
        (_ctx.onlyActive)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_4
            ], 64))
      ]),
      _createVNode(_component_InputSwitch, {
        modelValue: _ctx.onlyActive,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_ctx.onlyActive = $event)),
          _ctx.onUpdateOnlyActive
        ]
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ]),
    _createVNode(_component_AppTable, {
      ref: "table",
      filtersSchema: _ctx.filters,
      service: _ctx.service,
      stateKey: _ctx.stateKey,
      rowClass: _ctx.rowClass,
      showActions: false,
      onResetFilters: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onlyActive = true)),
      onRowClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onEdit($event.data)))
    }, {
      toolbarLeft: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_SplitButton, {
                icon: 'pi ' + (_ctx.exporting ? 'pi-spin pi-spinner' : 'pi-file-excel'),
                disabled: _ctx.exporting,
                label: "Export",
                model: _ctx.exports
              }, null, 8, ["icon", "disabled", "model"]),
              (!_ctx.isNew && !_ctx.isBroker)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    type: "button",
                    label: "Add Ticket",
                    class: "p-ml-2 p-button-warning",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayAddTicketDialog = true))
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      columns: _withCtx(({onApplyFilter}) => [
        _createVNode(_component_Column, {
          header: "Ticket Id",
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(" #" + _toDisplayString(data.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "Broker" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.broker?.business_name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "Full name" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.user.name) + " " + _toDisplayString(data.user.surname), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "Company name" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.user.company_name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Status",
          field: "status",
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_TicketStatus, {
                status: data.status
              }, null, 8, ["status"]),
              (_ctx.isDispute(data))
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "p-button-rounded p-button-info p-ml-1",
                    icon: "pi pi-comment",
                    onClick: ($event: any) => (_ctx.onResolve(data))
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('resolve dispute'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          filter: _withCtx(({filterModel}) => [
            _hoisted_7,
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.statusOptions,
              placeholder: "Select statuses",
              optionLabel: "label",
              "option-value": "value"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "clear",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "payment_status",
          header: _ctx.$t('ticket.table.payment_status'),
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          filter: _withCtx(({filterModel}) => [
            _createVNode(_component_Dropdown, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.paymentStatusOptions,
              placeholder: "Select Status",
              "option-value": "value",
              "option-label": "label"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: _ctx.$t('common.clear'),
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: _ctx.$t('common.apply'),
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createVNode(_component_PaymentStatus, {
              status: data.payment_status
            }, null, 8, ["status"])
          ]),
          _: 2
        }, 1032, ["header"]),
        _createVNode(_component_Column, {
          field: "datetime_assigned",
          header: "Start Date",
          style: {"min-width":"12rem"},
          sortable: true,
          showFilterMatchModes: false
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_DateFormatted, {
              date: data.datetime_start,
              format: "YYYY-MM-DD hh:mm A"
            }, null, 8, ["date"])
          ]),
          filter: _withCtx(({filterModel}) => [
            _createVNode(_component_Calendar, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              showIcon: true,
              dateFormat: "yy-mm-dd",
              placeholder: "from date"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "clear",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, {
          field: "datetime_end",
          header: "End Date",
          style: {"min-width":"12rem"},
          sortable: true,
          showFilterMatchModes: false
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_DateFormatted, {
              date: data.datetime_end,
              format: "YYYY-MM-DD hh:mm A"
            }, null, 8, ["date"])
          ]),
          filter: _withCtx(({filterModel}) => [
            _createVNode(_component_Calendar, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              showIcon: true,
              dateFormat: "yy-mm-dd",
              placeholder: "to date"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "clear",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, null, {
          header: _withCtx(() => [
            _hoisted_8
          ]),
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_ctx.getDuration(data)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "cycles",
          header: "Cycles",
          sortable: true
        }),
        (_ctx.canSeeTotalTon)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              header: _ctx.$t('ticket.total_ton'),
              style: {"min-width":"8rem"}
            }, {
              body: _withCtx(({data}) => [
                _createTextVNode(_toDisplayString(data.total_ton || '-'), 1)
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          field: "fee_driver",
          header: "Fee driver",
          style: {"min-width":"10rem"}
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_CurrencyText, {
              modelValue: data.fee_driver
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "finish_status",
          header: "Final Status",
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_TicketFinishStatus, { ticket: data }, null, 8, ["ticket"])
          ]),
          filter: _withCtx(({filterModel}) => [
            _hoisted_9,
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.finishStatusOptions,
              placeholder: "Select statuses",
              optionLabel: "label",
              "option-value": "value"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, { header: "Actions" }, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createVNode(_component_Button, {
                class: "p-button-info p-mr-1",
                icon: "pi pi-eye",
                onClick: _withModifiers(($event: any) => (_ctx.onEdit(data)), ["stop"])
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('open'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              (_ctx.canDelete(data))
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "p-button-danger p-mr-1",
                    label: _ctx.trashLabel(data),
                    icon: "pi pi-trash",
                    onClick: _withModifiers(($event: any) => (_ctx.onDelete(data)), ["stop"])
                  }, null, 8, ["label", "onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('delete'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["filtersSchema", "service", "stateKey", "rowClass"]),
    _createVNode(_component_AddTicketDialog, {
      visible: _ctx.displayAddTicketDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.displayAddTicketDialog = $event)),
      "shift-id": _ctx.shift.id,
      brokers: _ctx.brokers,
      onSelected: _ctx.onAdd
    }, null, 8, ["visible", "shift-id", "brokers", "onSelected"]),
    _createVNode(_component_TicketDisputeResolverDialog, {
      ticket: _ctx.selectedTicket,
      visible: _ctx.displayResolverDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.displayResolverDialog = $event)),
      header: "Resolve dispute - Refund",
      onResolved: _ctx.onResolved,
      onCancel: _ctx.onResolveCancel
    }, null, 8, ["ticket", "visible", "onResolved", "onCancel"])
  ], 64))
}